import type { Station as ServiceStation } from './api/station/Station'

export class Station {
  id: number
  latitude: number
  longitude: number
  altitude: number
  synop: any
  idema: any
  ubi: any
  stationType?: string
  heightStationSea: number
  source: string
  stationName?: string
  aemetType: string

  constructor(serviceStation: ServiceStation) {
    this.id = serviceStation.ID_STATION
    this.latitude = serviceStation.LATITUDE
    this.longitude = serviceStation.LONGITUDE
    this.altitude = serviceStation.ALT
    this.synop = serviceStation.SYNOP
    this.idema = serviceStation.IDEMA
    this.ubi = serviceStation.UBI
    this.source = serviceStation.SOURCE
    this.stationType = serviceStation.STATION_TYPE
    this.heightStationSea = serviceStation.HEIGHT_STATION_SEA
    this.stationName = serviceStation.STATION_NAME
    this.aemetType = serviceStation.AEMET_TYPE
  }

  isObservacion() {
    return this.aemetType.includes('OBSERVACION')
  }

  isSynop() {
    return this.aemetType === 'SYNOP'
  }

  getName() {
    return this.stationName || this.ubi
  }
}
